import { createContext } from 'react';
const ElementContext = createContext(undefined);
export default ElementContext;
//# sourceMappingURL=ElementContext.js.map